import { inject, Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { catchError, Observable } from 'rxjs';
import { OrganizationService } from '@doc/api/server-bo';

@Injectable({
  providedIn: 'root'
})
export class OrganizationResolver implements Resolve<any> {

  private organizationService = inject(OrganizationService);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.organizationService.getAllOrganizations({}).pipe(
      catchError(error => {
        return [];
      })
    )
  }
}
